import Needs from "@/views/needs/needs/Needs.vue";
import Need from "@/views/needs/NeedCommon.vue";
import NeedsDashboard from "@/views/enterprise/needsDashboard/NeedsDashboard.vue";

export default [
    {
        path: '/needs',
        component: Needs,
        meta: {
            access: ['enterprise'],
        }
    },
    {
        path: '/needs-dashboard',
        component: NeedsDashboard,
        meta: {
            access: ['enterprise'],
        }
    },
    {
        path: '/needs/:id',
        component: Need,
        meta: {
            access: ['enterprise', 'ecosystem']
        }
    },
]
